const size = {
  sm: {
    fontSize: "10px",
    lineHeight: "28",
    borderRadius: "10px",
  },
  md: {
    fontSize: "14px",
    height: "32px",
    borderRadius: "15px",
  },
  lg: {
    fontSize: "16px",
    height: "40px",
    borderRadius: "15px",
  },
};

export const link = {
  size,
};
